<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <span class="text-h6 font-weight-bold">Настройка оптимизированного заказа</span>
            </v-col>
        </v-row>
        <v-row align="center">
            <v-col cols="3" class="text-left">
                <span>Минимальный срок годности (месяц)</span>
            </v-col>
            <v-col cols="2">
                <v-text-field 
                    v-model="optimizeOption.minPriceExpiry" 
                    label="Введите срок" 
                    type="number" 
                    dense 
                    clearable
                    hide-details 
                    outlined 
                    prepend-icon="mdi-update">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row align="center">
            <v-col cols="3" class="text-left">
                <span>Учитывать остатки</span>
            </v-col>
            <v-col cols="2">
                <v-checkbox
                    v-model="optimizeOption.stockEnable"
                    prepend-icon="mdi-apps-box"
                />
            </v-col>
        </v-row>
        <v-row align="center">
            <v-col cols="3" class="text-left">
                <span>Учитывать кратность</span>
            </v-col>
            <v-col cols="2">
                <v-checkbox
                    v-model="optimizeOption.takeIntoMultiplicity"
                    prepend-icon="mdi-math-norm-box"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-btn small color="primary" @click="UpdateOptions()">Сохранить</v-btn>
            </v-col>
        </v-row>
        <v-divider style="margin: 10px;"></v-divider>
        <v-row align="center">
            <v-col class="text-left">
                <div>
                    <v-btn color="primary" @click="openModal">
                        Видимость дитрибьюторов
                    </v-btn>
                </div>
            </v-col>

            <!-- модальное окно для выбора -->
            <v-dialog v-model="dialog" max-width="600px" persistent>
                <v-card>
                    <v-card-title>
                        Настройка доступов
                    </v-card-title>

                    <v-card-text>
                        <v-autocomplete
                            v-model="selectedCities"
                            :items="accessibleCities"
                            item-text="name"
                            item-value="id"
                            label="Доступные города"
                            multiple
                            chips
                            clearable
                            deletable-chips
                            :loading="loading"
                            :disabled="loading"
                            :search-input.sync="citySearch"
                            hide-selected
                            no-data-text="Ничего не найдено"
                        />
                        <v-autocomplete
                            v-model="selectedFilials"
                            :items="filteredFilials"
                            item-text="name"
                            item-value="id"
                            label="Доступные филиалы"
                            multiple
                            chips
                            clearable
                            deletable-chips
                            :loading="loading"
                            :disabled="loading || selectedCities.length === 0"
                            :search-input.sync="filialSearch"
                            hide-selected
                            no-data-text="Ничего не найдено"
                        />
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer />

                        <v-btn text @click="dialog=false">
                            Отмена
                        </v-btn>

                        <v-btn
                            color="primary"
                            :loading="saving"
                            :disabled="loading || saving"
                            @click="saveSelectedFilials"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <div style="margin-top: 10px;">
        <template>
            <v-row align="center">
                <v-col cols="3" class="text-left">
                    <span>Сортировать детали заказа по алфавиту</span>
                </v-col>

                <v-col cols="2">
                    <v-checkbox
                        v-model="isOrderDetailsAlphabetSorting"
                        prepend-icon="mdi-sort-alphabetical-ascending"
                    />
                </v-col>
            </v-row>
        </template>
    </div>
    </v-container>
</template>

<script>
export default {
    inject: ["theme"],
    data: () => ({
        dialog: false,
        loading: false,
        saving: false,

        selectedFilials: [],
        accessibleFilials: [],

        selectedCities: [],
        accessibleCities: []
    }),
    computed: {
        userSettings() {
            return this.$store.state.order.userSettings;
        },

        isOrderDetailsAlphabetSorting: {
            get() {
                return this.userSettings?.isOrderDetailsAlphabetSorting ?? false;
            },

            set(value) {
                this.$store.dispatch(
                    "ADJUST_ORDER_DETAILS_ALPHABET_SORTING",
                    value
                );
            }
        },
        stringValues: {
            get() {
                return this.$store.getters.STRING_VALUES;
            },
        },
        currentLanguage: {
            get() {
                return this.$store.getters.CURRENT_LANG;
            }
        },
        optimizeOption: {
            get() {
                return this.$store.getters.OPTIMIZE_ORDER_OPTIONS;
            }
        },
        filteredFilials() {
            return this.accessibleFilials.filter(filial =>
                this.selectedCities.includes(filial.cityId)
            );
        }
    },
    watch: {
        selectedCities() {
            const avaibleFilialIds = this.filteredFilials.map(x => x.id);

            this.selectedFilials = this.selectedFilials.filter(id =>
                avaibleFilialIds.includes(id)
            );
        }
    },
    methods: {
        async openModal(){
            this.dialog = true;
            this.loading = true;

            try{
                const data = 
                    await this.$store.dispatch('GET_USER_ACCESS');
                
                    this.accessibleFilials = data.companyAccessFilials;
                    this.selectedFilials = data.userAccessFilialIds;

                    this.selectedCities = data.userAccessCityIds;
                    this.accessibleCities = data.companyAccessCities;
            }
            catch (error) {
                window.console.log(error);
            }
            finally{
                this.loading = false;
            }
        },
        async saveSelectedFilials(){
            this.saving = true;
            
            try{
                await this.$store.dispatch('UPDATE_USER_ACCESS', {
                    cityIds: this.selectedCities,
                    filialIds: this.selectedFilials
                });

                this.dialog = false;

                 this.$store.commit('SET_SNACKBAR', {
                    text: 'Данные успешно обновлены!',
                    timeout: 5000,
                    color: 'success',
                    show: true,
                });
            }
            catch (error) {
                this.$store.commit('SET_SNACKBAR', {
                    text: 'Произошла ошибка!',
                    timeout: 5000,
                    color: 'error',
                    show: true,
                });

                window.console.log(error);
            }
            finally {
                this.saving = false;
            }
        },
        UpdateOptions() {
            this.$store
                .dispatch("UPDATE_OPTIONS", this.optimizeOption)
                .then(() => {
                    var Snackbar = {
                        text: "Изменения сохранены",
                        timeout: 5000,
                        color: "success",
                        linkText: "",
                        show: true,
                    };

                    this.$store.commit("SET_SNACKBAR", Snackbar);
                })
                .catch(() => {
                    var Snackbar = {
                        text: "Ошибка",
                        timeout: 5000,
                        color: "red",
                        linkText: "",
                        show: true,
                    };
                    this.$store.commit("SET_SNACKBAR", Snackbar);
                });
        },
        GetOptionsByContext() {
            this.$store
                .dispatch("USER_OPTIONS")
                .then(() => {
                })
                .catch((error) => {
                    window.console.log(error);
                });
        }
    },
    async mounted() {
        this.GetOptionsByContext();
        await this.$store.dispatch("GET_USER_SETTINGS");
    }
}
</script>